import { statusLookup } from "../DataManagement/DataManagement";
import { ZT } from "./ZeroTrustData";

export interface IFZTReducer {
    name: string;
    cost: number;
    description: string;
    filename: string;
    pillars: string[];
    phases: string[];
    showPopup: boolean;
    showImport: boolean;
    showPhase: string;
    selectedCtr: string;
    scores: Record<string, number>;
    metrics: any;
}
  
export const emptyZTReducer: IFZTReducer = {
    showPopup: false,
    showImport: true,
    showPhase: '',
    selectedCtr: '1.1.1',
    name: '',
    cost: 0,
    description: '',
    filename: '',
    pillars: [],
    phases: [],
    scores: {},
    metrics: {},
};

function getScores(metrics:any){
    const childReg = /\d+\.\d+\./;
    let scores:any = {'controls' : {}, 'phaseOrder' : {}, 'pillars' : {},};
    Object.keys(ZT.ztmap).forEach((zid:any) => {
        if(!childReg.test(zid)) return;
        let zscore = 0;
        const total = ZT.ztmap[zid].length;
        if(total === 0){
            scores.controls[zid] = 0;
            return;
        }
        ZT.ztmap[zid].forEach((nid:any) => {
            const status = metrics?.[nid]?.status || 'None';
            const score = statusLookup[status].score;
            zscore += score;
        });
        scores.controls[zid] = Number((zscore / total).toFixed(2));
    })

    Object.keys(ZT.phaseOrder).forEach((phase:any) => {
        const total = ZT.phaseOrder[phase].length;
        let zscore = 0;
        if(total === 0){
            scores.phaseOrder[phase] = 0;
            return;
        }
        ZT.phaseOrder[phase].forEach((zid:any) => {
            zscore += scores.controls[zid];
        });
        scores.phaseOrder[phase] = Number((zscore / total).toFixed(2));
    });

    Object.keys(ZT.pillars).forEach((pillar:any) => {
        const zids = Object.keys(scores.controls).filter((str:string) => str.charAt(0) === pillar);
        const total = zids.length;
        let zscore = 0;
        if(total === 0){
            scores.pillars[pillar] = 0;
            return;
        }
        
        zids.forEach((zid:any) => {
            zscore += scores.controls[zid];
        });
        scores.pillars[pillar] = Number((zscore / total).toFixed(2));
    });

    return scores;
}

export default function ZeroTrustReducer(state:any, action:any){
    switch(action.type) {
        case 'update':
            return {
                ...state,
                [action.field]: action.payload,
            };
        case 'init':
            return {
                ...state,
                ...action.payload
            };
        case 'closePopup':
            return {
                ...state,
                showPopup: false,
            };
        case 'setPopup':
            return {
                ...state,
                showPopup: true,
                selectedCtr: action.payload,
            };
        case 'updateMetrics':
            return {
                ...state,
                metrics: getScores(action.payload),
            };
        default:
            return state;
    }
};